import { DatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { useState } from "react";

export type TruxSimpleDateFieldProps = {
  value?: string,
  onChange: (a: string | undefined) => void,
  label?: string,
  disabled?: boolean,
  limitWidth?: boolean,
  small?: boolean
}

export default function TruxSimpleDateField({ value, onChange, disabled = false, label, limitWidth = true, small }: TruxSimpleDateFieldProps) {
  const [open, setOpen] =  useState(false);
  return <DatePicker
    label={label}
    value={!value ? null : dayjs(value as any)}
    onChange={(date: Dayjs | null) => { onChange(date && date.isValid() ? date.format("YYYY-MM-DD") : undefined) }}
    disabled={disabled}
    open={open}
    onOpen={() => setOpen(true)}
    onClose={() => setOpen(false)}
    slotProps={{
      textField: {
        fullWidth: true,
        size: "small",
        onClick: small ? () => setOpen(true) : undefined,
        inputProps: small ? { readOnly: true } : undefined,
      },
      inputAdornment: small ? {
        sx: {
          display: 'none'
        }
      } : undefined
    }}
    sx={{
      // eslint-disable-next-line no-nested-ternary
      maxWidth: small ? "80px" :  (limitWidth ? { md: 180 } : undefined),
      width: "100%",
      '& input': small ? { cursor: 'pointer' } : undefined,
      '& .MuiInputBase-root': small ? {pr: '0px !important', '&:hover': {cursor: 'pointer !important'}} : undefined,
      '& .MuiInputBase-input': small ? { py: '2px', px: '4px', textAlign: 'center' } : undefined,
    }}
  />
}